import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bxl-running-analysis-shared',
  templateUrl: 'running-analysis-shared.component.html',
  styleUrls: ['running-analysis-shared.component.scss']
})
export class RunningAnalysisSharedComponent implements OnInit {
  initialized = false;


  constructor() { }

  ngOnInit(): void {
    this.initialized = true;
  }

}
